const strings = {
  labels: {
    header: 'Unable to sign in',
    body: `It looks like Contact Center Pro isn't active for you yet. 
    Reach out to a Pro Account Manager to find out more about our powerful new 
    centralized contact center product now.`,
  },
} as const;

export default strings;
